import {
  grey,
  primary,
  blueGrey,
} from '../../utils/brandColors';

export default () => ({
  paperRoot: {
    overflow: 'auto',
    marginTop: '1rem',
  },
  rowLocation: {
    borderBottom: `6px solid ${primary[500]}`,
    borderLeft: `4px solid ${blueGrey[50]}`,
  },
  row: { },
  cell: {
    borderRight: `1px solid ${grey[300]}`,
    maxWidth: 200,
    minWidth: 200,
  },
  cellTasks: {
    borderRight: `1px solid ${grey[300]}`,
    maxWidth: 200,
    minWidth: 200,
    padding: '0',
  },
  cellSchedule: {
    borderRight: `1px solid ${grey[300]}`,
    padding: '0',
    maxWidth: 200,
    minWidth: 200,
  },
  cellHead: {
    borderRight: `1px solid ${grey[300]}`,
    fontSize: 16,
    fontWeight: 600,
    textAlign: 'center',
    color: blueGrey[50],
    backgroundColor: primary[500],
  },
  cellHeadSmall: {
    borderRight: `1px solid ${grey[300]}`,
    fontSize: 16,
    fontWeight: 600,
    textAlign: 'center',
    color: blueGrey[50],
    backgroundColor: primary[500],
    width: 160,
  },
});
